import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/marketing",
    name: "marketing",
    component: dashboard,
    redirect: {
      name: "SXApplication"
    },
    children: [
      {
        path: "SXMarketing",
        name: "SXMarketing",
        meta: { title: "生效中的的二维码" },
        component: () => import("@/views/marketingSXTJ/sxMarketing.vue"),
        children: []
      }
    ]
  },
  {
    path: "/marketing",
    name: "marketing",
    component: dashboard,
    redirect: {
      name: "endApplication"
    },
    children: [
      {
        path: "marketingTimeInfo/:marketingId;:number;:marketingName",
        name: "marketingTimeInfo",
        meta: { title: "拍码统计" },
        component: () => import("@/views/marketingEnd/marketingTimeindex.vue")
      }
    ]
  }
];
